import type { INotificationCreatedByUser } from '../api/types';

export const getNotificationCreatedByLabel = (
  createdByUser: INotificationCreatedByUser | null,
): string => {
  if (!createdByUser) return '—';

  const fullName = `${createdByUser.firstName} ${createdByUser.lastName}`.trim();
  return fullName || createdByUser.username || '—';
};
